import { Icon } from 'src/features/ui/components/Icon';
import { Organization } from '../types/Organization';

export type OrganizationChipProps = {
  organization: Organization;
};

export const OrganizationChip = ({ organization }: OrganizationChipProps): JSX.Element => (
  <div className="border-solid-1 flex h-8 items-center justify-center gap-2 rounded-full border border-grey-2 bg-grey-3 px-3 text-sm  text-white">
    <Icon icon="organization" />
    {organization.name}
  </div>
);
